var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.initialized
      ? _c("div", [_c("i", { staticClass: "fas fa-spinner fa-spin fa-3x" })])
      : _vm._e(),
    _vm._v(" "),
    _vm.initialized
      ? _c(
          "div",
          { staticClass: "wcarousel" },
          [
            _c("div", { staticClass: "tools top" }, [
              _c("div", { staticClass: "tools-row" }, [
                _c("div", { staticClass: "change-size fa-2x" }, [
                  _vm.previewSize === "big"
                    ? _c("a", {
                        staticClass: "fas fa-angle-double-left",
                        attrs: { title: "change size small", href: "#" },
                        on: {
                          click: function($event) {
                            _vm.previewSize = "small"
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.previewSize !== "big"
                    ? _c("a", {
                        staticClass: "fas fa-angle-double-right",
                        attrs: { title: "change size big", href: "#" },
                        on: {
                          click: function($event) {
                            _vm.previewSize = "big"
                          }
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.mode === "multiple"
                  ? _c("div", { staticClass: "selectors" }, [
                      _vm.items.length > 0 &&
                      _vm.items.length === _vm.selected.length
                        ? _c("a", {
                            staticClass: "fas fa-check-circle fa-2x select_all",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                return _vm.toggleAll(false)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.items.length > 0 &&
                      _vm.items.length > _vm.selected.length
                        ? _c("a", {
                            staticClass: "far fa-circle fa-2x unselect_all",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                return _vm.toggleAll(true)
                              }
                            }
                          })
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "virtual-list",
              {
                attrs: {
                  debounce: 200,
                  size: _vm.size,
                  remain: _vm.remain,
                  wtag: "div",
                  start: _vm.start
                }
              },
              _vm._l(_vm.items, function(item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("wxm-gallery-card", {
                      key: item.id,
                      attrs: {
                        index: index,
                        "object-name": item.objectname,
                        "object-id": item.id,
                        visible: item.visible,
                        title: item.data.title,
                        src:
                          _vm.previewSize === "big"
                            ? item.data["src-big"]
                            : item.data["src-small"],
                        fileViewSrc: item.data.fileViewSrc,
                        zoom: item.data["src-magnify"],
                        "with-metas-hiddable": true,
                        metas: item.data.metas,
                        status: item.data.status,
                        "with-btn-edit": false,
                        "with-btn-view": false,
                        selectable: !(_vm.mode === "single"),
                        selected: item.selected,
                        "with-btn-active": true,
                        active: _vm.active === index || false,
                        "with-btn-file-view": true
                      },
                      on: {
                        "image-clicked": _vm.onImageClicked,
                        "set-selected": _vm.setSelected,
                        "set-active": _vm.setItemActive,
                        "preview-mouse-over": _vm.onPreviewMouseOver,
                        "preview-mouse-leave": _vm.onPreviewMouseLeave
                      }
                    })
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "tools bottom" }, [
              _c("div", { staticClass: "tools-row" }, [
                _c("div", { staticClass: "wcarousel-pager" }, [
                  _c("div", { staticClass: "wcarousel-pager-prev" }, [
                    _c("a", {
                      staticClass:
                        "fas fa-2x fa-step-backward wcarousel-pagination-prev",
                      class: {
                        "wcarousel-pagination-disabled": _vm.start === 0
                      },
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.prev()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wcarousel-pager-pagination" }, [
                    _c("span", {
                      staticClass: "label label-info",
                      domProps: { textContent: _vm._s(_vm.nbrAssets) }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "wcarousel-pager-next" }, [
                    _c("a", {
                      staticClass:
                        "fas fa-2x fa-step-forward wcarousel-pagination-next",
                      class: {
                        "wcarousel-pagination-disabled":
                          _vm.start >= _vm.items.length
                      },
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.next()
                        }
                      }
                    })
                  ])
                ])
              ])
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }